import React, { Component } from 'react'
import { Auth } from "aws-amplify";
import { Link } from 'react-router-dom'
import { withToastManager } from 'react-toast-notifications'
import { AuthContext } from '../../contexts/auth'
import { Pane, Button, TextInput } from 'evergreen-ui'
import { Grid, Row, Col } from 'react-flexbox-grid';
import { withRouter } from 'react-router-dom';

class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      form: {
        email: {
          value: ''
        },
        password: {
          value: ''
        }
      },
      formValidation: {
        email: false,
        password: false,
      },
      formValid: false
    }
  }

  handleChange = (e) => {
    e.preventDefault()
    let { name, value } = e.target
    let { form } = this.state
    form[name].value = value
    this.setState({ form }, () => this.validateField(name, value))
  }

  validateField = (fieldName, value) => {
    let { formValidation } = this.state

    switch (fieldName) {
      case 'email':
        formValidation['email'] = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        break;
      case 'password':
        formValidation['password'] = value.length !== 0
        break;
      default:
        break;
    }
    this.setState({ formValidation }, this.validateForm)
  }

  validateForm() {
    const { email, password } = this.state.formValidation
    this.setState({ formValid: email && password })
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({
      isLoading: true
    })
    try {
      const { location } = this.props;
      console.log({ props: this.props.location })
      await Auth.signIn(this.state.form.email.value.toLowerCase(), this.state.form.password.value);

      this.context.userHasAuthenticated(true)
      const token = await Auth.currentSession();
      const cGroups = token.idToken.payload['cognito:groups'] || []
      const organization_type = token.idToken.payload['custom:organization_type']
      const isAdmin = cGroups.filter((gr) => gr === 'admin').length > 0
      this.context.userIsAdmin(isAdmin);
      this.context.setRoles(cGroups)
      this.context.setOrgType(organization_type)
      this.setState({ isLoading: false })
      if (location.state) {
        let url = new URL(location.state.prevUrl)
        if (url.searchParams.get("from") && url.searchParams.get("to")) {
          return this.props.history.push(`/${location.state.prevUrl.split('/').pop()}`);
        }
      }
    } catch (e) {
      this.props.toastManager.add(e.message, { appearance: 'error' })
      this.setState({ isLoading: false })
    }
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <Pane>
          <Grid>
            <Row>
              <Col md={12}>
                <TextInput
                  name='email'
                  type='email'
                  onChange={this.handleChange}
                  value={this.state.email}
                  className='form-control'
                  placeholder='Email Address'
                  width="100%"
                  marginTop={16}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <TextInput
                  name='password'
                  type='password'
                  value={this.state.password}
                  onChange={this.handleChange}
                  placeholder='Password'
                  marginTop={16}
                  width="100%"
                  marginBottom={16}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <p style={{ marginTop: 0, fontSize: '20px' }}>
                  <Link to='/forgot-password'>Forgot password?</Link>
                  <br />
                  <Link to='/signup'>New? Register here</Link>
                </p>
              </Col>
              <Col md={6} style={{ textAlign: 'right' }}>
                <Button
                  isLoading={this.state.isLoading}
                  height={48}
                  appearance="primary"
                  intent="success"
                  disabled={!this.state.formValid}
                >
                  Sign in
                  </Button>
              </Col>
            </Row>
          </Grid>
        </Pane>
      </form>
    )
  }
}

LoginForm.contextType = AuthContext;
export default withRouter(withToastManager(LoginForm))